function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense, useEffect, useMemo, useState } from 'react';
import Parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { catchError, from, map } from 'rxjs';
import { useObservable } from 'rxjs-hooks';
import { Preloader } from '@procom-labs/atoms';
import { ClientNames, PreferredLanguageType, toKebabCase, useClientService } from '@procom-labs/common';
import { LegalDocuments } from './legal-documents';
var style = "<style>\n    .mainDiv { margin-top: 16px; padding-block: 20px; width: fit-content}\n    h2 { font-size: 2rem; font-weight: 500; margin-block: 0 }\n    .overline {line-height: 2.66;\n    text-transform: uppercase;\n    margin-bottom: 0.35em; font-size: 1.203rem;}\n    .footer {font-size: 12px; text-align: center}\n    </style>";
var getTermFetchRequest = function(clientName, lang) {
    return from(import("../../assets/html/".concat(clientName, "/terms-of-use-").concat(lang)));
};
export var TermsOfUsePage = function(param) {
    var handleBack = param.handleBack, lang = param.lang;
    var i18n = useTranslation('main').i18n;
    var clientService = useClientService();
    var _useState = _sliced_to_array(useState(''), 2), content = _useState[0], setContent = _useState[1];
    var clientName = useObservable(function() {
        return clientService.clientSetting$.pipe(map(function(settings) {
            return settings ? toKebabCase(settings.common.name) : null;
        }));
    }, null);
    var localLng = useMemo(function() {
        var _i18n_language;
        return lang || ((_i18n_language = i18n.language) === null || _i18n_language === void 0 ? void 0 : _i18n_language.toLowerCase()) || PreferredLanguageType.EN;
    }, [
        lang,
        i18n.language
    ]);
    var parsedHtml = useMemo(function() {
        return (content === null || content === void 0 ? void 0 : content.trim()) ? Parse(style + content) : '';
    }, [
        content
    ]);
    useEffect(function() {
        var subscription = null;
        if (clientName) {
            subscription = getTermFetchRequest(clientName, localLng).pipe(catchError(function() {
                return getTermFetchRequest(ClientNames.Procom.toLowerCase(), localLng);
            })).subscribe({
                next: function(value) {
                    setContent(value.TermsOfUse);
                },
                error: function() {
                    return setContent('');
                }
            });
        }
        return function() {
            if (subscription && !subscription.closed) {
                subscription.unsubscribe();
            }
        };
    }, [
        clientName,
        localLng
    ]);
    if (content) {
        return /*#__PURE__*/ _jsx(Suspense, {
            fallback: /*#__PURE__*/ _jsx(Preloader, {
                center: true
            }),
            children: /*#__PURE__*/ _jsx(LegalDocuments, {
                handleBack: handleBack,
                children: parsedHtml
            })
        });
    }
    return null;
};
